module.exports = __webpack_public_path__ + "img/21-FCP-update-your-resume-to-reflect-your-experience-and-new-skills.0b762847.svg";